import React from 'react';
import VoxelDialogActionCancel from '../../../components/voxel/Dialogs/VoxelDialogActionCancel';
import VoxelDialogActionSubmit from '../../../components/voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../../components/voxel/Dialogs/VoxelDialogActions';
import { TeamConnectionGq } from '../../../graphql/users/models/TeamConnectionGq';
import { usersApiService } from '../../../graphql/users/usersApiService';
import VoxelDialogContent from '../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelAlertDialog from '../../../components/voxel/Dialogs/VoxelAlertDialog';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import VoxelDialog from '../../../components/voxel/Dialogs/VoxelDialog';

export interface DeleteConnectionDialogProps {
  connection: TeamConnectionGq;
  onSuccess: () => Promise<unknown>;
  close: () => void;
}

export const DeleteConnectionDialog: React.FC<DeleteConnectionDialogProps> = ({
  connection,
  onSuccess,
  close,
}) => {
  const deleteMutation = usersApiService.mutations.useRemoveConnectedTeam();
  const handleRemoveConnection = () => {
    return deleteMutation({ connectionId: connection.id }).then(onSuccess).then(close);
  };

  if (!connection) return null;

  return (
    <VoxelDialog title="Are you sure?" onClose={close} open>
      <VoxelDialogContent>
        {connection.sharingTeam && connection.receivingTeam ? (
          <VoxelText>
            The following action will delete the connection between{' '}
            <span className="font-semibold">{connection?.sharingTeam.name}</span> and{' '}
            <span className="font-semibold">{connection?.receivingTeam.name}</span> permanently.
          </VoxelText>
        ) : (
          <VoxelText>The following action will remove the invitation.</VoxelText>
        )}
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionCancel onClick={close} />
        <VoxelDialogActionSubmit
          startIcon={<FontAwesomeIcon icon={faTrash} />}
          title={
            connection.sharingTeam && connection.receivingTeam
              ? 'Remove connection'
              : 'Remove invitation'
          }
          onClick={handleRemoveConnection}
        />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default DeleteConnectionDialog;
